<div class="page-container">
    <div fxLayout="column">
        <app-page-header [section]="'Atoku'" [title]="'Pricing Profiles'"
            [description]="'Manage pricing profiles and compare prices across stations, storage, and equipment.'"></app-page-header>

        <div class="page-padding page-content full-screen-height-page-default" fxLayout="column" fxLayoutGap="24px">
            <div class="atoku-filter-bar" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
                <mat-form-field class="custom-text-field atoku-search-field" appearance="outline" floatLabel="always">
                    <mat-label>Search Profiles</mat-label>
                    <input matInput (keyup)="applyProfileFilter($event)" placeholder="Search by code or name...">
                    <mat-icon matSuffix color="primary">search</mat-icon>
                </mat-form-field>
            </div>

            <div class="table-card mat-elevation-z3" fxLayout="column">
                <div class="atoku-card-header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="16px">
                    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="12px">
                        <div class="atoku-card-actions">
                            <button class="button-action" mat-flat-button type="button" (click)="addProfile()">
                                <mat-icon>add</mat-icon>
                                <div class="button-text">Create Profile</div>
                            </button>

                            <button class="button-action" mat-flat-button type="button" *ngIf="hasSingleSelection"
                                (click)="editSelectedProfile()">
                                <mat-icon>edit</mat-icon>
                                <div class="button-text">Edit</div>
                            </button>

                            <button class="button-action" mat-flat-button type="button" *ngIf="hasSelection"
                                (click)="removeSelectedProfiles()">
                                <mat-icon>delete</mat-icon>
                                <div class="button-text">Remove</div>
                            </button>
                        </div>
                    </div>
                </div>

                <table mat-table class="custom-table" [dataSource]="filteredProfiles">
                    <ng-container matColumnDef="table-label">
                        <th mat-header-cell class="custom-table-label" *matHeaderCellDef
                            [attr.colspan]="profileColumns.length"> Profiles </th>
                    </ng-container>

                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let profile">
                            <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                                (change)="toggleProfileSelection(profile)" [checked]="selection.isSelected(profile)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="code">
                        <th mat-header-cell *matHeaderCellDef> Code </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let profile"> {{ profile.code }} </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Name </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let profile"> {{ profile.name }} </td>
                    </ng-container>

                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef> Description </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let profile"> {{ profile.description }} </td>
                    </ng-container>

                    <tr mat-header-row class="custom-table-header" *matHeaderRowDef="['table-label']"></tr>
                    <tr mat-header-row class="custom-table-header" *matHeaderRowDef="profileColumns"></tr>
                    <tr mat-row class="custom-table-row profile-row" *matRowDef="let row; columns: profileColumns;"
                        [class.atoku-selected-row]="selection.isSelected(row)"
                        [class.profile-row-selected]="row.code === activeProfileCode" (click)="selectProfile(row)"></tr>
                </table>
            </div>

            <div class="table-card mat-elevation-z3" fxLayout="column">
                <div class="pricing-toolbar" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="16px">
                    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
                        <mat-form-field class="custom-text-field compare-field" appearance="outline" floatLabel="always">
                            <mat-label>Compare With</mat-label>
                            <mat-select [(value)]="compareProfileCode">
                                <mat-option [value]="null">None</mat-option>
                                <mat-option *ngFor="let profile of compareProfiles" [value]="profile.code">
                                    {{ profile.code }} - {{ profile.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <span class="body-1-regular-2 active-profile-label">
                            Active Profile: <strong>{{ activeProfile.code }}</strong> ({{ activeProfile.name }})
                        </span>
                    </div>

                    <span class="body-1-regular-2 compare-status" *ngIf="compareProfileCode">
                        Comparing against {{ compareProfileCode }}
                    </span>

                    <button mat-raised-button color="primary" (click)="savePrices()"
                        [disabled]="!hasUnsavedChanges || isSaving">
                        Save Prices
                    </button>
                </div>

                <mat-tab-group animationDuration="0ms" (selectedTabChange)="setTab($event.index)">
                    <mat-tab label="Stations"></mat-tab>
                    <mat-tab label="Storage"></mat-tab>
                    <mat-tab label="Equipment"></mat-tab>
                </mat-tab-group>

                <table mat-table class="custom-table" [dataSource]="itemRows">
                    <ng-container matColumnDef="table-label">
                        <th mat-header-cell class="custom-table-label" *matHeaderCellDef
                            [attr.colspan]="itemPriceColumns.length">
                            {{ selectedTab | titlecase }} Pricing ({{ activeProfile.code }})
                        </th>
                    </ng-container>

                    <ng-container matColumnDef="code">
                        <th mat-header-cell *matHeaderCellDef> Code </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let row"> {{ row.code }} </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Name </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let row"> {{ row.name }} </td>
                    </ng-container>

                    <ng-container matColumnDef="currentPrice">
                        <th mat-header-cell *matHeaderCellDef> {{ activeProfile.code }} Price </th>
                        <td mat-cell class="custom-table-cell editable-price-cell" *matCellDef="let row">
                            <div class="inline-price-editor" (click)="$event.stopPropagation()">
                                <span class="inline-price-prefix">R</span>
                                <input class="inline-price-input" type="number" min="0" step="1"
                                    [value]="row.currentPrice"
                                    (input)="updatePrice(row, $any($event.target).value)">
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="comparePrice">
                        <th mat-header-cell *matHeaderCellDef> {{ compareProfileCode }} Price </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let row"> R{{ (row.comparePrice || 0) | number:'1.2-2' }} </td>
                    </ng-container>

                    <ng-container matColumnDef="variance">
                        <th mat-header-cell *matHeaderCellDef> Variance </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let row"
                            [class.variance-up]="(row.variance || 0) > 0"
                            [class.variance-down]="(row.variance || 0) < 0">
                            {{ (row.variance || 0) > 0 ? '+' : '' }}R{{ (row.variance || 0) | number:'1.2-2' }}
                        </td>
                    </ng-container>

                    <tr mat-header-row class="custom-table-header" *matHeaderRowDef="['table-label']"></tr>
                    <tr mat-header-row class="custom-table-header" *matHeaderRowDef="itemPriceColumns"></tr>
                    <tr mat-row class="custom-table-row" *matRowDef="let row; columns: itemPriceColumns;"></tr>
                </table>
            </div>
        </div>
    </div>
</div>
